import axios from 'axios';
import Config from '../../../cankado-config';
import events from '../../event-names';
import { apiHeaders } from '../../../kado/utils/';

export default (ass, answers) => dispatch =>
    dispatch({
        type: events.DOCUMENT_QUESTION,
        payload: axios.patch(`${Config.apiRoot}/patient/assessments/${ass}/answers/`, [...answers], { ...apiHeaders() }),
    });